require('./sendPinByMailViewContainer.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');

// @ actions
const sendPinByMailActions = require('actions/sendPinByMail');
const PrinterActions = require('actions/contactCenter/printer');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const SendPinByMailView = require('components/myProfile/sendPinByMail/sendPinByMailView');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const SendPinByMailErrorStep = require('components/myProfile/sendPinByMail/sendPinByMailErrorStep/sendPinByMailErrorStep');
const SendPinByMailSuccessStep = require('components/myProfile/sendPinByMail/sendPinByMailSuccessStep/sendPinByMailSuccessStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const pageTitle = formatText('accountModifyStep-pageTitle');
// @ utilities
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname')

class SendPinByMailViewContainer extends React.Component {
    constructor(props) {
        super(props);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    isReady() {
        const { immSendPinData } = this.props;
        !immSendPinData.get('isFetching');
    }


    beforeLeaving() {
        const { immSendPinData } = this.props;
        if (immSendPinData.get('submitSuccessful') && immSendPinData.get('willLeave')) {
            this.props.immSendPinData.reset();
        }
    }

    handleConfirmLeave() {
        this.props.reset();
        this.props.resetPrintedIndicators();
    }

    buildError() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <SendPinByMailErrorStep
                immCard={immCard}
            />
        );
    }

    buildSuccessful() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <SendPinByMailSuccessStep
                immCard={immCard}
            />
        );
    }

    buildWizard() {
        const { match: { params: { cardId } }, immCards, immProfileFields, immUserData, immCodeOTPData, immKeysData, immSendPinData, setVisibleStep, validateStep, sendPinSuccess, setWillCancel } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <div className="row no-outside-gutter">
                <SendPinByMailView
                    immCards={immCard}
                    immProfileFields={immProfileFields}
                    immUserData={immUserData}
                    immCodeOTPData={immCodeOTPData}
                    immKeysData={immKeysData}
                    immSendPinData={immSendPinData}
                    setVisibleStep={setVisibleStep}
                    validateStep={validateStep}
                    sendPinSuccess={sendPinSuccess}
                    cardId={cardId}
                    setWillCancel={setWillCancel}
                />
            </div>
        );
    }

    render() {
        let content;
        let passContent = (<div></div>);
        const { match: { params: { cardId } }, immCards, immSendPinData, immProfileFields } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const submitSuccessful = immSendPinData.get('submitSuccessful');
        const errorReceived = immSendPinData.get('errorReceived');


        const confirmationMessage = formatText('preleaveCancelModal-confirmationMessagePreleave');
        const confirmationTitle = formatText('preleaveCancelModal-confirmationTitleMessagePreleave');
        const acceptText = formatText('preleaveCancelModal-cancelButton');
        const cancelText = formatText('preleaveCancelModal-stayHereButton');
        const mappingBreadcrumb = [
            {
                text: formatText('accountModifyStep-pageTitle'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardMoreOptions-sendPin'),
                url: ''
            }
        ]

        if (submitSuccessful) {
            content = this.buildSuccessful();
        } else if (errorReceived) {
            content = this.buildError();
        } else {
            const wizard = immProfileFields.get('isFetching') ? (<LoadingSection />) : this.buildWizard();

            passContent = (
                <div>
                    <PreLeaveModalComponent
                        confirmationMessage={confirmationMessage}
                        confirmationTitle={confirmationTitle}
                        acceptText={acceptText}
                        cancelText={cancelText}
                        isReady={this.isReady}
                        beforeLeaving={this.beforeLeaving}
                        onConfirmLeave={this.handleConfirmLeave}
                    />
                    {wizard}
                </div>
            );

            content = (

                <section className="account-modify-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            {passContent}
                        </div>
                        <div className="col-xs-4">
                            <CardDetailsSideBar immCard={immCard} />
                        </div>
                    </div>
                    {content}
                </section>
            );
        }

        const keysViewClassName = conditionalClassName('keys-view', 'send-pin-by-email')
        const keysViewContainerClassName = conditionalClassName('keys-view__container', 'send-pin-by-email__body')
        return (
            <section className={keysViewClassName}>
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className={keysViewContainerClassName}>
                    {content}
                </div>
            </section>
        );
    }
}


SendPinByMailViewContainer.propTypes = {
    immUserData: PropTypes.object,
    resetPrintedIndicators: PropTypes.func.isRequired,
    immCodeOTPData: PropTypes.object,
    immKeysData: PropTypes.object,
    immProfileFields: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immSendPinData: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object.isRequired,
    sendPinSuccess: PropTypes.func,
    isReady: PropTypes.func,
    match: PropTypes.object.isRequired,
    setWillCancel: PropTypes.object.isRequired,
    reset: PropTypes.object.isRequired,
};

module.exports.constructor = SendPinByMailViewContainer;
module.exports.SendPinByMailViewContainer = connect(
    state => ({
        immUserData: state.userData,
        resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
        immPrinter: state.printer,
        immCodeOTPData: state.codeOtp,
        immKeysData: state.recoveryKeys,
        immProfileFields: state.profile,
        immSendPinData: state.sendPinByMail,
        immCards: state.cards,
        immCardSecurePayment: state.cardSecurePayment,
    }), {
    setVisibleStep: sendPinByMailActions.setVisibleStep,
    resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
    validateStep: sendPinByMailActions.validateStep,
    sendPinSuccess: sendPinByMailActions.sendPinSuccess,
    setWillCancel: sendPinByMailActions.setWillCancel,
    reset: sendPinByMailActions.reset,
})(SendPinByMailViewContainer);
